import { Tag } from 'antd';

const COLOR_MAP: Record<string, string> = {
  ACTIVE: 'green',
  PUBLISHED: 'green',
  INVITED: 'gold',
  DRAFT: 'default',
  DEACTIVATED: 'red',
};

const StatusBadge = ({ status, label }: { status: string; label: string }) => (
  <Tag color={COLOR_MAP[status] ?? 'default'} className="font-figtree">
    {label}
  </Tag>
);

export default StatusBadge;
